module.exports = __webpack_public_path__ + "static/media/logoSmall.8be7314b.svg";